// アプリケーション共通の定数

export const DUMMY = 'dummy'; // ダミー値（import形式維持用。他定数が追加されて定数が2個以上になったら消してOK)
export const IS_DISP_FEE = false; // 料金表示フラグ